import script from "./StepMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./StepMessage.vue?vue&type=script&setup=true&lang=js"

import "./StepMessage.vue?vue&type=style&index=0&id=bd0207cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd0207cc"]])

export default __exports__